import { Dropdown } from '@/components/Dropdown/Dropdown';
import { Input } from '@/components/Input/Input';
import { Label } from '@/components/Label/Label';

type InputLabelProps = {
	dropdown?: 'zipCodes' | 'cities' | 'streets';
	id: string;
	labelText?: string;
	list?: string;
	name: string;
	required?: boolean;
	type: string;
} & Record<string, unknown>;

const InputLabel = (props: InputLabelProps) => {
	const inputProps = { ...props };
	delete inputProps.labelText;

	return (
		<>
			<Input
				className="form--text"
				{...inputProps}
			/>
			<Label
				htmlFor={props.id}
				required={props.required}
				text={props.labelText}
				{...props}
			/>
			{props.dropdown && props.list ? (
				<Dropdown
					dropdownType={props.dropdown}
					id={props.list}
				/>
			) : (
				''
			)}
		</>
	);
};

export { InputLabel };
